import {
  FETCH_LIST_ROLES_BY_ID_REQUEST,
  FETCH_LIST_ROLES_BY_ID_SUCCESS,
  FETCH_LIST_ROLES_BY_ID_FALUIRE,
} from './listRolesByRoleIDTypes'

const initialState = {
  loading: false,
  particularListRolesInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LIST_ROLES_BY_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LIST_ROLES_BY_ID_SUCCESS : return {
      ...state,
      particularListRolesInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LIST_ROLES_BY_ID_FALUIRE : return {
      ...state,
      loading: false,
      particularListRolesInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
